var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconanalyticsmaximize = function SvgIconanalyticsmaximize(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Analytics/icon.analytics.maximize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Analytics/icon.analytics.maximize",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#F6F6F6",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,0.5 L15.5,4.5 M15.5,0.5 L11.5,0.5 M9.5,6.5 L15.5,0.5",
    id: "Combined-Shape",
    stroke: "#909090",
    opacity: 0.498756772,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,9.5 L6.5,13.5 M6.5,9.5 L2.5,9.5 M0.5,15.5 L6.5,9.5",
    id: "Combined-Shape",
    stroke: "#909090",
    opacity: 0.498756772,
    strokeLinecap: "round",
    transform: "translate(3.500000, 12.500000) rotate(-180.000000) translate(-3.500000, -12.500000) "
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconanalyticsmaximize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.analytics.maximize.e708eece5d6ca0b26d3cb13e9a33d8c9.svg";